import classNames from 'classnames';
import React from 'react';
import { useMatchMedia } from '@udemy/hooks';
import { Icon } from '@udemy/icons';
import { Button } from '@udemy/react-core-components';
import { CarouselWithFocusOrder } from '@udemy/react-structure-components';
import { AlternateHeadline } from '../alternate-headline/alternate-headline.react-component';
import styles from "./learning-testimonials-unit.module.css";
export const LearningTestimonialsUnit = ({
  children,
  className,
  title,
  titleClassName,
  titleId,
  showCta = false,
  ctaHref,
  ctaLabel,
  ctaOnClick,
  ...carouselProps
}) => {
  const hasCoarsePointer = useMatchMedia('(any-pointer: coarse)');
  const hasFinePointer = useMatchMedia('(any-pointer: fine)');
  return /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": titleId,
    className: classNames(styles['testimonials-unit'], className)
  }, title && /*#__PURE__*/React.createElement(AlternateHeadline, {
    className: styles['heading'],
    "data-purpose": "unit-title",
    title: title,
    titleClass: titleClassName,
    titleId: titleId,
    titleTag: "h2"
  }), /*#__PURE__*/React.createElement(CarouselWithFocusOrder, Object.assign({
    allowScroll: !!hasCoarsePointer,
    gridMode: true,
    showPager: !!hasFinePointer
  }, carouselProps), children), showCta && ctaLabel && ctaHref && /*#__PURE__*/React.createElement(Button, {
    className: styles['cta'],
    componentClass: "a",
    href: ctaHref,
    onClick: ctaOnClick,
    udStyle: "ghost"
  }, ctaLabel, /*#__PURE__*/React.createElement(Icon, {
    label: false,
    glyph: "arrow-right",
    className: "ud-icon-bi-directional"
  })));
};
//# sourceMappingURL=learning-testimonials-unit.react-component.js.map